/**
 * UranIA PA — guscio condiviso per le pagine istituzionali pubbliche
 * (`/piattaforma`, `/trasparenza-ia`, `/accessibilita`, `/privacy` —
 * Riordino della mappa delle rotte §3, Rilascio A passo A.7: "già
 * promesse dai link di copertina e dovute a un sito pubblico").
 *
 * Non genera contenuto legale: dove i testi devono arrivare dal
 * committente (accessibilità, privacy) il chiamante passa `pending`
 * invece di `children` — vedi `PendingNotice` sotto.
 */

import { useTranslation } from 'react-i18next';
import { Link } from '@tanstack/react-router';
import type { JSX, ReactNode } from 'react';

interface InstitutionalPageShellProps {
  readonly badge: string;
  readonly title: string;
  readonly testId: string;
  readonly children?: ReactNode;
}

export function InstitutionalPageShell(props: InstitutionalPageShellProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <section className="container py-5" data-testid={props.testId}>
      <div className="mx-auto" style={{ maxWidth: 720 }}>
        <span
          className="badge mb-3"
          style={{
            backgroundColor: '#e7f1ff',
            color: '#084298',
            fontSize: '0.7rem',
            letterSpacing: '0.05em',
          }}
        >
          {props.badge}
        </span>
        <h1 className="h3 mb-4">{props.title}</h1>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <div>{props.children}</div>
          <Link to="/" className="align-self-start mt-3 small">
            {t('istituzionale.back_to_landing')}
          </Link>
        </div>
      </div>
    </section>
  );
}

/** Segnaposto esplicito per i testi legali non ancora disponibili — mai
 *  un testo generato al posto loro. */
export function PendingNotice(props: { readonly body: string }): JSX.Element {
  const { t } = useTranslation();
  return (
    <div className="alert alert-warning" role="alert">
      <strong className="d-block mb-1">{t('istituzionale.pending_alert_title')}</strong>
      <p className="mb-0">{props.body}</p>
    </div>
  );
}
